var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "link-arrow",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64888 2.86013C3.64888 3.2018 3.92343 3.47026 4.25899 3.47026H7.66951L2.42846 8.71126C2.19051 8.94921 2.19051 9.33359 2.42846 9.57154C2.6664 9.80949 3.05077 9.80949 3.28872 9.57154L8.52977 4.33054V7.74115C8.52977 8.07672 8.80432 8.35128 9.13989 8.35128C9.47545 8.35128 9.75 8.07672 9.75 7.74115V2.86013C9.75 2.52456 9.47545 2.25 9.13989 2.25H4.25899C3.92343 2.25 3.64888 2.52456 3.64888 2.86013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.8862ae9b13c840fa1c3554a8947105e5.svg";
export { ForwardRef as ReactComponent };